import { CButton, CNav, CNavItem, CNavLink } from "@coreui/react"
import {
  Popover,
  Switch,
  Table,
  DatePicker,
  Space,
  Button,
  Input,
  Select,
} from "antd"
import React, { useEffect } from "react"
import { useState } from "react"
import AddAbonement from "../Modals/AddAbonement"
import { formateDate } from "src/components/helpers/formateDate"
import { useDispatch, useSelector } from "react-redux"
import {
  deleteClientAbonement,
  frostClientAbonement,
  getAbonements,
  getAbonementsClient,
  getClientTrainings,
  getClubs,
} from "src/store/Slices/ClientsSlice"
import { openNotification } from "src/components/helpers/notification"
import { SearchOutlined } from "@ant-design/icons"
import SureModal from "src/components/Modals/SureModal"
import dayjs from "dayjs"
import EditTrainingModal from "../Modals/EditTrainingModal"
import { DeleteOutlined } from "@ant-design/icons"
import { useRef } from "react"
const { RangePicker } = DatePicker
const SecondTable = ({
  abonementRows,
  abonementColumns,
  abonementLoading,
  clientInfo,
  trainingRows,
  trainingColumns,
  trainingLoading,
  isDeleted,
  isActive,
  setIsDeleted,
  setIsActive,
  isDeletedTrain,
  isActiveTrain,
  setIsDeletedTrain,
  setIsActiveTrain,
  abonementTotalCount,
}) => {
  // HELPERS
  const dispatch = useDispatch()
  const scroll = { x: 0, y: 200 }

  const clubs = useSelector((state) => state.ClientsSlice.clubs)
  const abonements = useSelector((state) => state.ClientsSlice.abonements)

  // STATE
  const [tab, setTab] = useState("Абонементы")
  const [abonementModal, setAbonementModal] = useState(false)
  const [trainingModal, setTrainingModal] = useState(false)
  const [openDeliteAbonementModal, setOpenDeliteAbonementModal] =
    useState(false)
  const [abonementInfo, setAbonementInfo] = useState(null)
  const [trainingInfo, setTrainingInfo] = useState(null)
  const [clicked, setClicked] = useState(false)
  const [date, setDate] = useState([dayjs()])
  const [daysToFreeze, setDaysToFreeze] = useState(null)
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(5)
  const [sortByIdFrom, setSortIdFrom] = useState()
  const [sortByIdTo, setSortIdTo] = useState()
  const [sortByClub, setSortByClub] = useState()
  const [sortByAbonement, setSortByAbonement] = useState()
  const [sortByAbonementFrom, setSortByAbonementFrom] = useState()
  const [sortByAbonementTo, setSortByAbonementTo] = useState()
  const [sortByFreezeTo, setSortByFreezeTo] = useState()
  const [sortByLeftFrom, setSortByLeftFrom] = useState()
  const [sortByLeftTo, setSortByLeftTo] = useState()
  const [sortByDateFrom, setSortByDateFrom] = useState()
  const [sortByDateTo, setSortByDateTo] = useState()
  const [selectedKeys, setSelectedKyes] = useState("")
  const [dataIndex, setDataIndex] = useState("")

  const searchInput = useRef(null)

  // FUNCTIONS
  const onClickCanFrostAboniment = (id, frozen) => {
    dispatch(
      frostClientAbonement({
        clientId: clientInfo.id,
        abonementClubId: abonementInfo?.abonementClubId
          ? abonementInfo?.abonementClubId
          : id,
        frostDays: daysToFreeze && daysToFreeze,
      })
    ).then((value) => {
      let result = value.payload.data.isSuccess
      result &&
        dispatch(
          getAbonementsClient({
            clientId: clientInfo.id,
            isDeleted: isDeleted,
            isActive: isActive,
          })
        )
      openNotification({
        type: "success",
        message: `Абонемент успешно ${frozen ? "разморожен" : "заморожен"}`,
      })
      setClicked(false)
    })
  }

  const handleReset = (clearFilters) => {
    dispatch(
      getAbonementsClient({
        clientId: clientInfo.id,
        isDeleted: isDeleted,
        isActive: isActive,
      })
    )
    dispatch(getClientTrainings({ clientId: clientInfo.id }))
    setSortIdFrom()
    setSortIdTo()
    setSortByClub()
    setSortByAbonement()
    setSortByAbonementFrom()
    setSortByAbonementTo()
    setSortByFreezeTo()
    clearFilters()
    setSortByLeftFrom()
    setSortByLeftTo()
    setSortByDateFrom()
    setSortByDateTo()
    setSelectedKyes()
    setDataIndex()
  }

  const onClickSearchItem = (selectedKeys, dataIndex) => {
    setPage(1)
    setPageSize(20)
    setSelectedKyes(selectedKeys[0])
    setDataIndex(dataIndex)
    if (tab === "Абонементы") {
      dispatch(
        getAbonementsClient({
          clientId: clientInfo.id,
          isDeleted: isDeleted,
          isActive: isActive,
          idFrom: sortByIdFrom,
          idTo: sortByIdTo,
          clubId: sortByClub,
          abonementId: sortByAbonement,
          abonementStartFrom:
            sortByAbonementFrom &&
            dayjs(sortByAbonementFrom[0], "DD.MM.YYYY").format(
              "YYYY-MM-DDTHH:mm:ss"
            ),
          abonementStartTo:
            sortByAbonementFrom &&
            dayjs(sortByAbonementFrom[1], "DD.MM.YYYY").format(
              "YYYY-MM-DDTHH:mm:ss"
            ),
          AbonementEndFrom:
            sortByAbonementTo &&
            dayjs(sortByAbonementTo[0], "DD.MM.YYYY").format(
              "YYYY-MM-DDTHH:mm:ss"
            ),
          AbonementEndTo:
            sortByAbonementTo &&
            dayjs(sortByAbonementTo[1], "DD.MM.YYYY").format(
              "YYYY-MM-DDTHH:mm:ss"
            ),
          frozenFrom:
            sortByFreezeTo &&
            dayjs(sortByFreezeTo[0], "DD.MM.YYYY").format(
              "YYYY-MM-DDTHH:mm:ss"
            ),
          frozenTo:
            sortByFreezeTo &&
            dayjs(sortByFreezeTo[1], "DD.MM.YYYY").format(
              "YYYY-MM-DDTHH:mm:ss"
            ),
          [`${dataIndex}`]: selectedKeys[0],
        })
      )
    } else {
      dispatch(
        getClientTrainings({
          clientId: clientInfo.id,
          isActive: isActiveTrain,
          idFrom: sortByIdFrom,
          idTo: sortByIdTo,
          leftFrom: sortByLeftFrom,
          leftTo: sortByLeftTo,
          startDateFrom:
            sortByDateFrom &&
            dayjs(sortByDateFrom[0], "DD.MM.YYYY").format(
              "YYYY-MM-DDTHH:mm:ss"
            ),
          startDateTo:
            sortByDateFrom &&
            dayjs(sortByDateFrom[1], "DD.MM.YYYY").format(
              "YYYY-MM-DDTHH:mm:ss"
            ),
          endDateFrom:
            sortByDateTo &&
            dayjs(sortByDateTo[0], "DD.MM.YYYY").format("YYYY-MM-DDTHH:mm:ss"),
          endDateTo:
            sortByDateTo &&
            dayjs(sortByDateTo[1], "DD.MM.YYYY").format("YYYY-MM-DDTHH:mm:ss"),
          abonementRegistrationDateFrom:
            sortByDateFrom &&
            dayjs(sortByDateFrom[0], "DD.MM.YYYY").format(
              "YYYY-MM-DDTHH:mm:ss"
            ),
          abonementRegistrationDateTo:
            sortByDateTo &&
            dayjs(sortByDateFrom[0], "DD.MM.YYYY").format(
              "YYYY-MM-DDTHH:mm:ss"
            ),
          [`${dataIndex}`]: selectedKeys[0],
        })
      )
    }
  }

  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <div>
          {title !== "Дата рождения" &&
            title !== "№" &&
            title !== "Клуб" &&
            title !== "Абонемент" &&
            title !== "Абонемент С" &&
            title !== "Абонемент До" &&
            title !== "Заморожен До" &&
            title !== "Осталось" &&
            title !== "Действует С" &&
            title !== "Действует До" && (
              <Input
                ref={searchInput}
                placeholder={`Искать ${title}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => onClickSearchItem(selectedKeys, dataIndex)}
                style={{
                  marginBottom: 8,
                  display: "block",
                }}
              />
            )}
          {title === "Клуб" && (
            <div>
              <Select
                style={{ width: "100%", marginBottom: "8px" }}
                placeholder='Выбрать'
                onClick={() => dispatch(getClubs())}
                options={clubs?.data?.value}
                value={sortByClub}
                onChange={(e) => setSortByClub(e)}
              />
            </div>
          )}
          {title === "Абонемент" && (
            <div>
              <Select
                style={{ width: "100%", marginBottom: "8px" }}
                placeholder='Выбрать'
                onClick={() => dispatch(getAbonements())}
                value={sortByAbonement}
                onChange={(e) => setSortByAbonement(e)}
                options={abonements?.data?.value}
              />
            </div>
          )}
          {title === "№" && (
            <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
              <Input
                placeholder='От'
                type='number'
                value={sortByIdFrom}
                onChange={(e) => setSortIdFrom(e.currentTarget.value)}
              />
              <Input
                placeholder='До'
                type='number'
                value={sortByIdTo}
                onChange={(e) => setSortIdTo(e.currentTarget.value)}
              />
            </div>
          )}
          {title === "Абонемент С" && (
            <div style={{ marginBottom: "8px" }}>
              <RangePicker
                value={sortByAbonementFrom}
                onChange={setSortByAbonementFrom}
                format='DD.MM.YYYY'
              />
            </div>
          )}
          {title === "Абонемент До" && (
            <div style={{ marginBottom: "8px" }}>
              <RangePicker
                value={sortByAbonementTo}
                onChange={setSortByAbonementTo}
                format='DD.MM.YYYY'
              />
            </div>
          )}
          {title === "Заморожен До" && (
            <div style={{ marginBottom: "8px" }}>
              <RangePicker
                value={sortByFreezeTo}
                onChange={setSortByFreezeTo}
                format='DD.MM.YYYY'
              />
            </div>
          )}
          {title === "Осталось" && (
            <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
              <Input
                placeholder='От'
                type='number'
                value={sortByLeftFrom}
                onChange={(e) => setSortByLeftFrom(e.currentTarget.value)}
              />
              <Input
                placeholder='До'
                type='number'
                value={sortByLeftTo}
                onChange={(e) => setSortByLeftTo(e.currentTarget.value)}
              />
            </div>
          )}
          {title === "Действует С" && (
            <div style={{ marginBottom: "8px" }}>
              <RangePicker
                value={sortByDateFrom}
                onChange={setSortByDateFrom}
                format='DD.MM.YYYY'
              />
            </div>
          )}
          {title === "Действует До" && (
            <div style={{ marginBottom: "8px" }}>
              <RangePicker
                value={sortByDateTo}
                onChange={setSortByDateTo}
                format='DD.MM.YYYY'
              />
            </div>
          )}
        </div>
        <Space>
          <Button
            type='primary'
            onClick={() => onClickSearchItem(selectedKeys, dataIndex)}
            icon={<SearchOutlined />}
            size='small'
            style={{
              width: 90,
            }}
          >
            Искать
          </Button>
          <Button
            onClick={() => {
              if (clearFilters) {
                handleReset(clearFilters)
              }
            }}
            size='small'
            style={{
              width: 90,
            }}
          >
            Сбросить
          </Button>
          <Button
            type='link'
            size='small'
            onClick={() => {
              close()
            }}
          >
            Закрыть
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100)
      }
    },
    render: (text) => text,
  })

  const disabledDate = (current, { from }) => {
    setDaysToFreeze(Math.abs(current.diff(dayjs(), "days")) + 1)
    debugger
    return (
      Math.abs(current.diff(dayjs(), "days")) >=
      abonementInfo.frostDays - abonementInfo.frostUse
    )
  }

  const content = (
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
        <RangePicker
          value={date}
          disabledDate={disabledDate}
          onChange={setDate}
          format='DD.MM.YYYY'
          disabled={[true, false]}
        />
        <Space>
          <Button
            type='primary'
            size='small'
            style={{
              width: 90,
            }}
            onClick={() => {
              onClickCanFrostAboniment(
                abonementInfo.abonementClubId,
                abonementInfo.isFrozen,
                abonementInfo.daysToFreeze
              )
            }}
          >
            Заморозить
          </Button>
          <Button
            type='link'
            size='small'
            onClick={() => {
              setClicked(false)
            }}
          >
            Закрыть
          </Button>
        </Space>
      </div>
    </>
  )

  const formateAbonementRows = abonementRows?.map((element) => {
    return {
      ...element,
      abonementFrom: element.abonementFrom
        ? formateDate(element?.abonementFrom)
        : "",
      abonementTo: element.abonementTo ? formateDate(element?.abonementTo) : "",
      isFrozen:
        !element.isFrozen && element?.canFrost ? (
          <Popover content={content} open={clicked} title='Выберите дату до:'>
            <Switch
              onClick={() => {
                setAbonementInfo(element)
                setClicked(true)
              }}
              disabled={!element?.canFrost}
              defaultChecked
              value={element?.isFrozen}
            />
          </Popover>
        ) : (
          <Switch
            onChange={() => {
              onClickCanFrostAboniment(
                element.abonementClubId,
                element?.isFrozen
              )
            }}
            disabled={!element?.canFrost}
            defaultChecked
            value={element?.isFrozen}
          />
        ),
      frozenTo: element.frozenTo ? formateDate(element?.frozenTo) : "",
    }
  })

  const formateTrainingRows = trainingRows?.map((element) => {
    return {
      ...element,
      isPersonal: (
        <Switch disabled defaultChecked value={element?.isPersonal} />
      ),
      startDate: element.startDate ? formateDate(element.startDate) : "",
      endDate: element.endDate ? formateDate(element.endDate) : "",
    }
  })

  const title = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <CNav variant='tabs'>
          <CNavItem>
            <CNavLink
              style={{ cursor: "pointer" }}
              onClick={() => setTab("Абонементы")}
              active={tab === "Абонементы"}
            >
              Абонементы
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink
              style={{ cursor: "pointer" }}
              onClick={() => setTab("Услуги")}
              active={tab === "Услуги"}
            >
              Услуги
            </CNavLink>
          </CNavItem>
        </CNav>
        {tab === "Абонементы" && clientInfo.id ? (
          <div style={{ display: "flex", gap: "20px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              {!isDeleted && (
                <Switch
                  defaultValue={isActive}
                  unCheckedChildren='Неактивные'
                  checkedChildren='Активные'
                  onChange={() => {
                    setIsActive(!isActive)
                  }}
                />
              )}
              <Switch
                defaultValue={isDeleted}
                checkedChildren={<DeleteOutlined />}
                unCheckedChildren={<DeleteOutlined />}
                onChange={() => {
                  setIsDeleted(!isDeleted)
                  setIsActive(true)
                }}
              />
            </div>
            {!isDeleted && (
              <CButton
                size='sm'
                style={{ color: "#FFF" }}
                onClick={() => {
                  setAbonementModal(true)
                }}
              >
                Добавить
              </CButton>
            )}
          </div>
        ) : (
          <div style={{ display: "flex", gap: "10px" }}>
            {!isDeletedTrain && (
              <Switch
                defaultValue={isActive}
                unCheckedChildren='Неактивные'
                checkedChildren='Активные'
                onChange={() => {
                  setIsActiveTrain(!isActiveTrain)
                }}
              />
            )}
          </div>
        )}
      </div>
    )
  }

  const rowsAbonementsWithActions = () => {
    if (!isDeleted && abonementColumns) {
      return [
        ...abonementColumns.map((element) => {
          return {
            ...element,
            ...getColumnSearchProps(element.dataIndex, element.title),
          }
        }),
        {
          title: "Действия",
          key: "action",
          align: "center",
          render: (_, record) => (
            <a
              className='text-primary text-decoration-none'
              onClick={() => {
                setAbonementInfo(record)
                setOpenDeliteAbonementModal(true)
              }}
            >
              Удалить
            </a>
          ),
          width: 150,
        },
      ]
    } else {
      return [
        ...abonementColumns.map((element) => {
          return {
            ...element,
            ...getColumnSearchProps(element.dataIndex, element.title),
          }
        }),
      ]
    }
  }

  const rowsTrainingsWithActions = () => {
    if (isActiveTrain && trainingColumns) {
      return [
        ...trainingColumns.map((element) => {
          return {
            ...element,
            ...getColumnSearchProps(element.dataIndex, element.title),
          }
        }),
        {
          title: "Действия",
          key: "action",
          align: "center",
          render: (_, record) => (
            <a
              className='text-primary text-decoration-none'
              onClick={() => {
                setTrainingInfo(record)
                setTrainingModal(true)
              }}
            >
              Изменить
            </a>
          ),
          width: 150,
        },
      ]
    } else {
      return [
        ...trainingColumns.map((element) => {
          return {
            ...element,
            ...getColumnSearchProps(element.dataIndex, element.title),
          }
        }),
      ]
    }
  }

  const handleTableChange = (pagination, filters, sorter) => {
    if (tab === "Абонементы") {
      dispatch(
        getAbonementsClient({
          clientId: clientInfo.id,
          count: pagination.pageSize,
          offset: pagination.pageSize * (pagination.current - 1),
          orderBy: sorter?.column?.dataIndex,
          isDesc: sorter.order
            ? sorter.order === "ascend"
              ? true
              : false
            : undefined,
          isDeleted: isDeleted,
          isActive: isActive,
          idFrom: sortByIdFrom,
          idTo: sortByIdTo,
          clubId: sortByClub,
          abonementId: sortByAbonement,
          abonementStartFrom:
            sortByAbonementFrom &&
            dayjs(sortByAbonementFrom[0], "DD.MM.YYYY").format(
              "YYYY-MM-DDTHH:mm:ss"
            ),
          abonementStartTo:
            sortByAbonementFrom &&
            dayjs(sortByAbonementFrom[1], "DD.MM.YYYY").format(
              "YYYY-MM-DDTHH:mm:ss"
            ),
          abonementEndFrom:
            sortByAbonementTo &&
            dayjs(sortByAbonementTo[0], "DD.MM.YYYY").format(
              "YYYY-MM-DDTHH:mm:ss"
            ),
          abonementEndTo:
            sortByAbonementTo &&
            dayjs(sortByAbonementTo[1], "DD.MM.YYYY").format(
              "YYYY-MM-DDTHH:mm:ss"
            ),
          frozenFrom:
            sortByFreezeTo &&
            dayjs(sortByFreezeTo[0], "DD.MM.YYYY").format(
              "YYYY-MM-DDTHH:mm:ss"
            ),
          frozenTo:
            sortByFreezeTo &&
            dayjs(sortByFreezeTo[1], "DD.MM.YYYY").format(
              "YYYY-MM-DDTHH:mm:ss"
            ),
          [`${dataIndex}`]: dataIndex ? selectedKeys : undefined,
        })
      )
    } else {
      dispatch(
        getClientTrainings({
          clientId: clientInfo.id,
          count: pagination.pageSize,
          offset: pagination.pageSize * (pagination.current - 1),
          orderBy: sorter?.column?.dataIndex,
          isDesc: sorter.order
            ? sorter.order === "ascend"
              ? true
              : false
            : undefined,
          isActive: isActiveTrain,
          idFrom: sortByIdFrom,
          idTo: sortByIdTo,
          leftFrom: sortByLeftFrom,
          leftTo: sortByLeftTo,
          startDateFrom:
            sortByDateFrom &&
            dayjs(sortByDateFrom[0], "DD.MM.YYYY").format(
              "YYYY-MM-DDTHH:mm:ss"
            ),
          startDateTo:
            sortByDateFrom &&
            dayjs(sortByDateFrom[1], "DD.MM.YYYY").format(
              "YYYY-MM-DDTHH:mm:ss"
            ),
          endDateFrom:
            sortByDateTo &&
            dayjs(sortByDateTo[0], "DD.MM.YYYY").format("YYYY-MM-DDTHH:mm:ss"),
          endDateTo:
            sortByDateTo &&
            dayjs(sortByDateTo[1], "DD.MM.YYYY").format("YYYY-MM-DDTHH:mm:ss"),
          [`${dataIndex}`]: dataIndex ? selectedKeys : undefined,
        })
      )
    }
    setPage(pagination.current)
    setPageSize(pagination.pageSize)
  }

  const onClickYesDeleteAbonement = () => {
    dispatch(
      deleteClientAbonement({
        clientId: clientInfo.id,
        abonementClubId: abonementInfo.abonementClubId,
      })
    ).then(() => {
      dispatch(getAbonementsClient({ clientId: clientInfo.id }))
      setOpenDeliteAbonementModal(false)
      openNotification({
        type: "success",
        message: `Абонемент успешно удален`,
      })
    })
  }

  // USEEFFECTS
  useEffect(() => {
    clientInfo.id &&
      dispatch(
        getAbonementsClient({
          clientId: clientInfo.id,
          isDeleted: isDeleted,
          isActive: isActive,
        })
      )
  }, [isDeleted, isActive])

  useEffect(() => {
    clientInfo.id &&
      dispatch(
        getClientTrainings({
          clientId: clientInfo.id,
          isDeleted: isDeletedTrain,
          isActive: isActiveTrain,
        })
      )
  }, [isDeletedTrain, isActiveTrain])

  return (
    <>
      <SureModal
        visible={openDeliteAbonementModal}
        setVisible={setOpenDeliteAbonementModal}
        onClickYes={onClickYesDeleteAbonement}
      />
      <AddAbonement
        abonementModal={abonementModal}
        setAbonementModal={setAbonementModal}
        clientInfo={clientInfo}
      />
      <EditTrainingModal
        visible={trainingModal}
        setVisible={setTrainingModal}
        trainingInfo={trainingInfo}
        clientInfo={clientInfo}
      />
      <Table
        size='small'
        loading={tab === "Абонементы" ? abonementLoading : trainingLoading}
        dataSource={
          tab === "Абонементы" ? formateAbonementRows : formateTrainingRows
        }
        columns={
          tab === "Абонементы"
            ? abonementColumns && rowsAbonementsWithActions()
            : trainingColumns && rowsTrainingsWithActions()
        }
        title={title}
        scroll={scroll}
        pagination={{
          position: ["bottomRight"],
          defaultPageSize: pageSize,
          defaultCurrent: page,
          total: abonementTotalCount,
          current: page,
        }}
        onChange={handleTableChange}
      />
    </>
  )
}

export default SecondTable
